import { createReducer, on } from '@ngrx/store';
import * as DestinationActions from '../actions/destination.actions';
import {Destination} from '../../../services/api/destinations/destination.model';

export const destinationFeatureKey = 'destination';

export interface State {
  record: Destination;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(DestinationActions.loadDestination, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(DestinationActions.loadDestinationSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(DestinationActions.loadDestinationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(DestinationActions.clearDestinationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

